import { AuthType, init } from '@thoughtspot/visual-embed-sdk';

import Auth from 'modules/Auth';
import { getAuthenticationToken } from 'modules/api/thoughtspots';
import config, { thoughtspot } from 'config';
import { getLocaleObject } from 'modules/I18N';
import { CancelFunctions } from 'components/common/types';

export const isThoughtspotEnabled = config.environment !== 'local' && config.environment !== 'testing';

export const initialiseThoughtspot = (
  localeCode: string = getLocaleObject().localeCode,
  cancelFunctions?: CancelFunctions,
): void => {
  if (!isThoughtspotEnabled) return;

  const { email } = Auth.getData();

  init({
    thoughtSpotHost: thoughtspot.host,
    authType: AuthType.TrustedAuthTokenCookieless,
    username: email,
    getAuthToken: () => getAuthenticationToken(localeCode, cancelFunctions),
    autoLogin: true,
    callPrefetch: true,
    blockNonEmbedFullAppAccess: true,
  });
};
